import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { usePrefs } from "@/lib/context";
import { fetcher } from "@/lib/hooks";
import { PushToggle } from "@/components/PushToggle";

export function NotificationBell() {
  const { t, fdatetime } = usePrefs();
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["notifications"], queryFn: () => fetcher("/notifications"), refetchInterval: 20000 });
  const readAll = async () => { await api.post("/notifications/read-all"); qc.invalidateQueries({ queryKey: ["notifications"] }); };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative text-slate-500 hover:text-slate-900" data-testid="notification-bell">
          <Bell size={18} />
          {data?.unread > 0 && <span className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-600 px-1 text-[9px] font-bold text-white" data-testid="notification-count">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 rounded-sm p-0" data-testid="notification-panel">
        <div className="flex items-center justify-between border-b px-4 py-2.5">
          <span className="font-display font-bold">{t("notifications")}</span>
          <button onClick={readAll} className="text-[11px] text-[#996515] hover:underline" data-testid="notifications-read-all">{t("markAllRead")}</button>
        </div>
        <PushToggle />
        <div className="max-h-96 overflow-y-auto">
          {(data?.items || []).length === 0 && <p className="p-4 text-sm text-slate-500">{t("noData")}</p>}
          {(data?.items || []).map((n) => (
            <button key={n.id} onClick={() => n.link && nav(n.link)} className={`block w-full border-b border-slate-100 px-4 py-2.5 text-start text-sm hover:bg-slate-50 ${n.level === "alert" ? "border-s-4 border-s-rose-600 bg-rose-50 text-rose-900" : n.read ? "text-slate-500" : "font-medium text-slate-900"}`} data-testid={`notification-${n.id}`}>
              {!n.read && <span className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full bg-[#B8860B]" />}{n.text}
              <div className="mt-0.5 text-[10px] text-slate-400">{fdatetime(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
